import {Actor} from "@/models/SuedAgainst/Actor";

export class InMemoryActorRepository {
    all() {
        return [
            new Actor(0, 'Demandante'),
            new Actor(1, 'Demandado'),
        ]
    }

    /**
     * @param {Number} actorId
     * @return Actor|null
     */
    getById(actorId) {
        let actors = this.all();
        let actorFound = actors.filter((a) => a.id === actorId)
        if(actorFound.length > 0) {
            return actorFound[0];
        }
        return null;
    }
}
